import type { User, AuthenticationResponse, ResetPasswordRequest } from './types';
import type { AuthService } from '.';
import { extractPartnerSlug } from '../../session';
import delay from '../mockServiceDelay';

const MockShipiumRefreshToken =
  'shippi---Y0ZDQEifQ.eyJpc3ov2FjY29---iOjEyODYwMzZ9.C8gS1YGqjJ3K---g6e8bYJrEEDYiceu6KCLJKCHrA';
const mockUser: User = {
  userId: '8cb8e11d-fbd6-42a7-b369-613fb843179b',
  sessionPartnerId: 'e0758009-622f-45aa-8ccf-a23d212ds23',
  email: 'mac@justgreatcables.com',
  active: true,
  givenName: 'Mac',
  partners: [
    {
      partnerId: 'e0758009-622f-45aa-8ccf-a23d212ds23',
      partnerName: 'Just Great Cables',
      role: 'administrator',
      urlSlugName: 'just-great-cables',
    },
    {
      partnerId: 'e0758009-622f-45aa-8ccf-a23d212ds23',
      partnerName: 'Wyze',
      role: 'administrator',
      urlSlugName: 'wyze',
    },
  ],
  surname: 'Brown',
  sessionPartnerName: 'Just Great Cables',
  sessionPartnerRole: 'administrator',
  sessionPartnerUrl: extractPartnerSlug(window.location.pathname)
    ? extractPartnerSlug(window.location.pathname)
    : 'just-great-cables',
};

const mockShipiumUser: User = {
  userId: '8888e11d-fbd6-42a7-b369-613fb843179b',
  sessionPartnerId: 'e0758009-622f-45aa-8ccf-a23d212ds23',
  email: 'mac@shipium.com',
  active: true,
  givenName: 'Mac',
  partners: [
    {
      partnerId: 'e0758009-622f-45aa-8ccf-a23d212ds23',
      partnerName: 'Just Great Cables',
      role: 'administrator',
      urlSlugName: 'just-great-cables',
    },
    {
      partnerId: 'e0758009-622f-45aa-8ccf-a23d212ds23',
      partnerName: 'Wyze',
      role: 'administrator',
      urlSlugName: 'wyze',
    },
  ],
  surname: 'Brown',
  sessionPartnerName: 'Just Great Cables',
  sessionPartnerRole: 'administrator',
  sessionPartnerUrl: extractPartnerSlug(window.location.pathname)
    ? extractPartnerSlug(window.location.pathname)
    : 'just-great-cables',
};

const mockShipiumAuthorizationResponseFixture: AuthenticationResponse = {
  user: mockShipiumUser,
  accessToken: 'ya29.QQIBibTwvKkE39hY8mdkT_mXZoRh7Ub9cK9hNsqrxem4QJ6sQa36VHfyuBe',
  refreshToken: MockShipiumRefreshToken,
  expiresIn: 1372,
};

const mockAuthorizationResponseFixture: AuthenticationResponse = {
  user: mockUser,
  accessToken: 'ya29.QQIBibTwvKkE39hY8mdkT_mXZoRh7Ub9cK9hNsqrxem4QJ6sQa36VHfyuBe',
  refreshToken: 'eyJhSUzI1Ni---Y0ZDQEifQ.eyJpc3ov2FjY29---iOjEyODYwMzZ9.C8gS1YGqjJ3K---g6e8bYJrEEDYiceu6KCLJKCHrA',
  expiresIn: 1372,
};

export const mockAuthService: AuthService = {
  authenticateUser: async (requestParams) => {
    await delay();
    if (!/justgreatcables.com/.test(requestParams.email) && !/shipium.com/.test(requestParams.email)) {
      throw new Error('Invalid Credentials');
    }
    if (/shipium.com/.test(requestParams.email)) {
      console.log(mockShipiumAuthorizationResponseFixture);
      return mockShipiumAuthorizationResponseFixture;
    }
    return mockAuthorizationResponseFixture;
  },
  requestPasswordReset: async (req: ResetPasswordRequest) => {
    await delay();
    if (/error/.test(req.email)) {
      throw new Error('Error requesting password reset.');
    }
    return;
  },
  refresh: async () => {
    return mockAuthorizationResponseFixture;
  },
  refreshPoll: async () => {
    return mockAuthorizationResponseFixture;
  },
  changePartnerContext: async (newPartnerId: string) => {
    await delay();
    return mockAuthorizationResponseFixture;
  },
  revoke: async () => {
    await delay();
  },
  logout: async () => {
    await delay();
  },
  getVersionMetadata: async () => {
    await delay();
    return {
      version: process.env.REACT_APP_VERSION,
      buildTimestamp: Date.now(),
    };
  },
  fetchQzCert: async () => {
    await delay();
    return 'NA';
  },
  qzSign: async (toSign: string) => {
    await delay();
    return 'NA';
  },
};

export default mockAuthService;
